import { render, staticRenderFns } from "./UniversalFilters.vue?vue&type=template&id=71dce76e&scoped=true"
import script from "./UniversalFilters.vue?vue&type=script&lang=js"
export * from "./UniversalFilters.vue?vue&type=script&lang=js"
import style0 from "./UniversalFilters.vue?vue&type=style&index=0&id=71dce76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dce76e",
  null
  
)

export default component.exports